import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Menu,
  MenuItem,
  Badge,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { setDark } from "../../store/feature/commonSlice";

import NotificationsIcon from "@mui/icons-material/Notifications";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import {
  useLogOutMutation,
  useGetProfileDetailsQuery,
} from "../../store/services/userApi";

const Header = () => {
  const dispatch = useDispatch();
  const common = useSelector((state) => state.common);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [currentBalance, setCurrentBalance] = useState(() => {
    const saved = localStorage.getItem("lastBalance");
    return saved ? Number(saved) : 0;
  });

  const [profileImage, setProfileImage] = useState(() => {
    return localStorage.getItem("lastProfileImage") || "";
  });

  const [customerName, setCustomerName] = useState(() => {
    const saved = localStorage.getItem("lastCustomerName");
    return saved || "USER";
  });

  const { data: profileData, error } = useGetProfileDetailsQuery();
  const [logOut, { isLoading: isLoggingOut }] = useLogOutMutation();

  useEffect(() => {
    if (profileData?.data?.parameter?.total_bal !== undefined) {
      const newBalance = Number(profileData.data.parameter.total_bal);
      setCurrentBalance(newBalance);
      localStorage.setItem("lastBalance", newBalance);
    }
  }, [profileData]);

  useEffect(() => {
    if (profileData?.data?.customer_name) {
      const newName = profileData.data.customer_name;
      setCustomerName(newName);
      localStorage.setItem("lastCustomerName", newName);
    }
  }, [profileData]);

  useEffect(() => {
    if (profileData?.data?.profile_image) {
      let imagePath = profileData.data.profile_image;
      if (imagePath.startsWith("uploads/")) {
        imagePath = imagePath.replace(/^\/?uploads\//, "uploads/");
      }
      const newImage = `https://onespace.fabmediatech.com/${imagePath}`;
      setProfileImage(newImage);
      localStorage.setItem("lastProfileImage", newImage);
    }
  }, [profileData]);

  useEffect(() => {
    if (error?.data?.status === false) {
      handleLogout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleProfileClick = () => {
    navigate("/profile");
    handleClose();
  };

  // const handleLogout = async () => {
  //   try {
  //     const refreshToken = localStorage.getItem("refreshToken");
  //     await logOut({ refreshToken }).unwrap();
  //     localStorage.removeItem("accessToken");
  //     localStorage.removeItem("refreshToken");
  //     localStorage.removeItem("reseller");
  //     localStorage.removeItem("lastBalance");
  //     localStorage.removeItem("lastCustomerName");
  //     localStorage.removeItem("lastProfileImage");
  //     document.cookie =
  //       "refreshToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  //     navigate("/login");
  //   } catch (err) {
  //     localStorage.removeItem("accessToken");
  //     localStorage.removeItem("refreshToken");
  //     localStorage.removeItem("reseller");
  //     localStorage.removeItem("lastBalance");
  //     localStorage.removeItem("lastCustomerName");
  //     localStorage.removeItem("lastProfileImage");
  //     navigate("/login");
  //   }
  // };

  const handleLogout = async () => {
    try {
      const refreshToken = localStorage.getItem("refreshToken");
      await logOut({ refreshToken }).unwrap();

      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("reseller");
      localStorage.removeItem("lastBalance");
      localStorage.removeItem("lastCustomerName");
      localStorage.removeItem("lastProfileImage");

      localStorage.removeItem("workflows");

      Object.keys(localStorage).forEach((key) => {
        if (
          key.startsWith("workflow-edit-graph-") ||
          key.startsWith("workflow-graph-") ||
          key.startsWith("workflow-meta-") ||
          key.startsWith("workflow-services-")
        ) {
          localStorage.removeItem(key);
        }
      });

      document.cookie =
        "refreshToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

      navigate("/login");
    } catch (err) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("reseller");
      localStorage.removeItem("lastBalance");
      localStorage.removeItem("lastCustomerName");
      localStorage.removeItem("lastProfileImage");

      localStorage.removeItem("workflows");

      Object.keys(localStorage).forEach((key) => {
        if (
          key.startsWith("workflow-edit-graph-") ||
          key.startsWith("workflow-graph-") ||
          key.startsWith("workflow-meta-") ||
          key.startsWith("workflow-services-")
        ) {
          localStorage.removeItem(key);
        }
      });

      navigate("/login");
    }
  };
  const handleDarkMode = () => {
    dispatch(setDark(!common.dark));
  };

  const menuItems = [
    {
      label: "Edit Profil",
      icon: <AccountCircleOutlinedIcon sx={{ fontSize: 17 }} />,
      onClick: handleProfileClick,
      color: "#60a5fa",
    },
    {
      label: "Change Password",
      icon: <LockOutlinedIcon sx={{ fontSize: 17 }} />,
      onClick: () => {
        navigate("/change-password");
        handleClose();
      },
      color: "#a78bfa",
    },
    {
      label: "My Rates",
      icon: <PercentOutlinedIcon sx={{ fontSize: 17 }} />,
      onClick: () => {
        navigate("/my-rates");
        handleClose();
      },
      color: "#34d399",
    },
  ];

  return (
    <AppBar
      position="static"
      sx={{
        background: "rgba(43, 45, 52, 0)",

        color: "#fff",
        width: "100%",
        height: 64,
        boxShadow: "0 1px 0 rgba(255,255,255,0.06)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.07)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "flex-end",
          minHeight: "64px !important",
          px: { xs: 2, sm: 4 },
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {/* Dark Mode Toggle */}
          <Tooltip title={common.dark ? "Switch to Light" : "Switch to Dark"}>
            <IconButton
              onClick={handleDarkMode}
              size="small"
              sx={{
                width: 36,
                height: 36,
                borderRadius: "10px",
                background: "rgba(255, 255, 255, 0.47)",
                border: "1px solid rgba(255,255,255,0.08)",
                color: common.dark ? "#fbbf24" : "#94a3b8",
                transition: "all 0.2s ease",
                "&:hover": {
                  background: "rgba(255,255,255,0.1)",
                  color: common.dark ? "#fde68a" : "#cbd5e1",
                  borderColor: "rgba(255,255,255,0.15)",
                  transform: "scale(1.05)",
                },
              }}
            >
              {common.dark ? (
                <LightModeIcon sx={{ fontSize: 18 }} />
              ) : (
                <DarkModeIcon sx={{ fontSize: 18 }} />
              )}
            </IconButton>
          </Tooltip>
          {/* Balance Chip */}
          <Tooltip title="Available Balance">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                background:
                  "linear-gradient(135deg, rgba(198, 52, 211, 0.12) 0%, rgba(165, 16, 185, 0.08) 100%)",
                border: "1px solid rgba(187, 187, 187, 0.2)",
                borderRadius: "10px",
                px: 1.5,
                py: 0.7,
                mx: 0.5,
                cursor: "default",
                transition: "all 0.2s ease",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, rgba(202, 202, 202, 0.61) 0%, rgba(255, 255, 255, 0.14) 100%)",
                  borderColor: "#b445e7ff",
                },
              }}
            >
              <CurrencyRupeeIcon sx={{ fontSize: 14, color: "#b445e7ff" }} />
              <Typography
                sx={{
                  fontSize: "0.82rem",
                  fontWeight: 700,
                  color: "#b445e7ff",
                  letterSpacing: "0.3px",
                  fontFamily: "'DM Mono', 'Fira Code', monospace",
                  whiteSpace: "nowrap",
                }}
              >
                {Number(currentBalance).toFixed(3)}
              </Typography>
            </Box>
          </Tooltip>

          {/* Divider */}
          <Box
            sx={{
              width: "1px",
              height: 28,
              background: "rgba(255,255,255,0.08)",
              mx: 0.5,
            }}
          />

          {/* Avatar + Name */}
          <Box
            onClick={handleClick}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              cursor: "pointer",
              borderRadius: "10px",
              px: 1,
              py: 0.5,
              background:
                "linear-gradient(135deg, rgba(198, 52, 211, 0.12) 0%, rgba(165, 16, 185, 0.08) 100%)",
              border: "1px solid rgba(187, 187, 187, 0.2)",
              transition: "all 0.2s ease",
              "&:hover": {
                background:
                  "linear-gradient(135deg, rgba(202, 202, 202, 0.61) 0%, rgba(255, 255, 255, 0.14) 100%)",
                borderColor: "#b445e7ff",
              },
            }}
          >
            <Avatar
              src={profileImage || undefined}
              alt={customerName}
              sx={{
                width: 32,
                height: 32,
                fontSize: "0.8rem",
                fontWeight: 700,
                background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                border: "2px solid rgba(99,102,241,0.4)",
                boxShadow: "0 0 0 1px rgba(255,255,255,0.06)",
              }}
            >
              {!profileImage && customerName?.[0]?.toUpperCase()}
            </Avatar>
            <Box
              sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}
            >
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.9)",
                  fontSize: "0.78rem",
                  fontWeight: 600,
                  letterSpacing: "0.3px",
                  fontFamily: "'DM Sans', sans-serif",
                  lineHeight: 1.2,
                }}
              >
                {customerName}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.35)",
                  fontSize: "0.65rem",
                  fontFamily: "'DM Sans', sans-serif",
                  lineHeight: 1.2,
                }}
              >
                Account
              </Typography>
            </Box>
            <KeyboardArrowDownIcon
              sx={{
                fontSize: 16,
                color: "rgba(255,255,255,0.3)",
                transition: "transform 0.2s ease",
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          </Box>
        </Box>

        {/* Dropdown Menu */}
        <Menu
          id="profile-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          PaperProps={{
            sx: {
              background: "rgba(10, 15, 30, 0.9)",
              backdropFilter: "blur(28px)",
              WebkitBackdropFilter: "blur(28px)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "14px",
              boxShadow:
                "0 16px 48px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.04)",
              color: "#fff",
              mt: 1.5,
              minWidth: 200,
              overflow: "hidden",
            },
          }}
          MenuListProps={{ sx: { py: 1 } }}
        >
          {/* Profile Header in Menu */}
          <Box sx={{ px: 2, py: 1.5, mb: 0.5 }}>
            <Typography
              sx={{
                fontSize: "0.82rem",
                fontWeight: 600,
                color: "rgba(255,255,255,0.9)",
                fontFamily: "'DM Sans', sans-serif",
              }}
            >
              {customerName}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.72rem",
                color: "rgba(255,255,255,0.35)",
                fontFamily: "'DM Sans', sans-serif",
                mt: 0.2,
              }}
            >
              Manage your account
            </Typography>
          </Box>

          <Divider sx={{ borderColor: "rgba(255,255,255,0.07)", mx: 1 }} />

          {menuItems.map((item) => (
            <MenuItem
              key={item.label}
              onClick={item.onClick}
              sx={{
                mx: 1,
                my: 0.3,
                borderRadius: "8px",
                px: 1.5,
                py: 1,
                fontSize: "0.82rem",
                fontFamily: "'DM Sans', sans-serif",
                color: "rgba(255,255,255,0.7)",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                transition: "all 0.15s ease",
                "& .menu-icon": {
                  color: item.color,
                  transition: "color 0.15s ease",
                },
                "&:hover": {
                  background: "rgba(255,255,255,0.05)",
                  color: "#fff",
                  "& .menu-icon": {
                    color: item.color,
                    filter: "brightness(1.2)",
                  },
                },
              }}
            >
              <Box className="menu-icon">{item.icon}</Box>
              {item.label}
            </MenuItem>
          ))}

          <Divider
            sx={{ borderColor: "rgba(255,255,255,0.07)", mx: 1, my: 0.5 }}
          />

          <MenuItem
            onClick={handleLogout}
            disabled={isLoggingOut}
            sx={{
              mx: 1,
              my: 0.3,
              borderRadius: "8px",
              px: 1.5,
              py: 1,
              fontSize: "0.82rem",
              fontFamily: "'DM Sans', sans-serif",
              color: "rgba(248,113,113,0.7)",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              transition: "all 0.15s ease",
              "&:hover": {
                background: "rgba(239,68,68,0.1)",
                color: "#f87171",
              },
              "&.Mui-disabled": { opacity: 0.4 },
            }}
          >
            <LogoutOutlinedIcon sx={{ fontSize: 17 }} />
            {isLoggingOut ? "Logging out…" : "Logout"}
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
